import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { verifyNewBankCard } from 'services/bankManagements'
import posthog from 'posthog-js'

export default function useSetVerifiedCard() {
    const navigate = useNavigate()
    const { isLoading, mutate, data } = useMutation({
        mutationFn: (cardNumber: number) => {
            return verifyNewBankCard(cardNumber)
        },
        onSuccess: (_, variables) => {
            toast.success('کارت با موفقیت ثبت شد')
            posthog.capture('bank_account_added', {
                bank_account_id: (variables as any),
            })
            navigate(-1)
        },
        onError: () => {
            posthog.capture('bank_account_add_failed')
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutateVerify: mutate, data }
}
